import React, { FormEventHandler, useState } from 'react';
import { validate } from 'email-validator';
import { CognitoUser } from 'amazon-cognito-identity-js';
import userPool from '../../utils/userPool';
import { Link, useNavigate } from 'react-router-dom';
import * as UI from '../common';

import { Alert } from 'flowbite-react';
import { InputComponent } from '../core/Forms';
import LogoBlack from '../LogoBlack';

const ForgetPasswordView = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [buttonText, setButtonText] = useState('Send Password Reset Code');

  const [formData, setFormData] = useState({
    email: '',
  });

  const handleInputChange = (event: { currentTarget: { name: any; value: any; }; }) => {
    const { name, value } = event.currentTarget;
    setFormData({ ...formData, [name]: value });
  };

  const handleForgetPassword: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();

    setIsLoading(true);
    setErrorMessage('');

    const isEmailValid = validate(formData.email);

    if (!isEmailValid) {
      setErrorMessage('Please enter a valid email address');
      setIsLoading(false);
      return;
    }


    const user = new CognitoUser({ Username: formData.email, Pool: userPool });

    user.forgotPassword({
      onSuccess: () => {
        setIsLoading(false);
        setButtonText('Password link sent');
        setIsSuccess(true);
        navigate(`/auth/reset-password?email=${formData.email}`);
      },
      onFailure: (err) => {
        setIsLoading(false);
        setErrorMessage('There was an error');
      },
    });
  };

  return (
    <div className="bg-[#F2F9FD] min-h-screen mt-0 lg:mt-72 pt-[260px] lg:py-[10px]">
        <div className='flex justify-center lg:hidden 375:ml-[8em] 414:ml-[10em] 360:ml-[8em] 412:ml-[9em] 540:ml-[13em] bigmd:ml-[24em]  w-[99.56px] mt-[-15em] md:ml-[20em] md:w-[160px] '>
        <LogoBlack />
        </div>
      <div className="lg:text-center text-center mb-[40px] mt-[10em] md:mt-[10em] lg:mt-[-3em]">
        <h1 className="text-[20px] font-bold lg:text-[32px] lg:font-bold md:text-[32px]  ">Reset your Password</h1>
        <p className="lg:py-[30px] text-[14px] lg:text-[16px] font-light md:text-[16px]">We will send you a reset password code</p>
        {errorMessage ? <Alert color="failure">{errorMessage}</Alert> : null}
      </div>
      <div className="lg:flex-col lg:items-center lg:justify-center lg:min-h-screen lg:mx-auto lg:ml-[2em]">
        <div className="lg:w-full lg:px-6 lg:rounded-lg">
          <form onSubmit={handleForgetPassword}>
            <div className="flex justify-center lg:flex lg:justify-center lg:placeholder:text-[15.25px] lg:h-[48px] ">
              <div className="lg:rounded lg:p-1 lg:w-[434px] ">
                <label htmlFor="Email" className="lg:block lg:font-sm lg:text-[13px] lg:text-black text-[12px]">
                  Email
                </label>
                <InputComponent
                  placeholder="Email"
                  name="email"
                  type="text"
                  value={formData.email}
                  handleChange={handleInputChange}
                  handleOnInput={handleInputChange}
                  handleOnFocus={handleInputChange}
                  handleOnBlur={handleInputChange}
                  className="w-[280px] md:w-[434px] lg:w-[434px] mb-[20px]"
                />
              </div>
            </div>

            <div className="lg:h-[48px]  flex justify-center mb-[40px] lg:flex lg:justify-center  lg:py-[55px] lg:mx-auto lg:w-[434px] ">
              <div className="lg:w-[434px] lg:ml-[1em] w-[285px] text-[16px] md:w-[434px] ">
                <UI.Button text={buttonText} variant={isSuccess ? 'success' : 'primary'} isLoading={isLoading} />
              </div>
            </div>
            <div className="lg:flex lg:justify-center lg:pt-[31px]">
              <Link
                to="/"
                className="flex text-center text-[11px] justify-center text-blue-700 font-sans font-semibold lg:flex lg:text-center lg:py-[13px] lg:pb-[26px] lg:font-sans lg:font-italic lg:font-semibold lg:text-base lg:leading-none lg:underline lg:text-blue-700"
              >
                <i>Go back to sign up</i>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export { ForgetPasswordView };

